import React, { useState } from 'react';
import PropTypes from 'prop-types';

import { format } from 'date-fns';
import Alert from '@material-ui/lab/Alert';
import Collapse from '@material-ui/core/Collapse';
import IconButton from '@material-ui/core/IconButton';
import CloseIcon from '@material-ui/icons/Close';

import { Container, Content, Label, Value } from './styles';

const Ticket = ({ data, dispensed_by }) => {
  const [open, setOpen] = useState(true);

  const { factor, manufacturer, quantity, validity, lot, received_by } = data();

  const date = new Date();
  const dateParsed = format(date, 'dd/MM/yyyy');
  const hourParsed = format(date, 'HH:mm:ss');

  return (
    <Container>
      <Collapse in={open}>
        <Alert
          action={
            <IconButton
              aria-label="close"
              color="inherit"
              size="small"
              onClick={() => {
                setOpen(false);
              }}
            >
              <CloseIcon fontSize="inherit" />
            </IconButton>
          }
          style={{ marginBottom: 10, borderRadius: 0 }}
          severity="success"
        >
          Medicamento registrado!
        </Alert>
      </Collapse>

      <Content id="ticket">
        <div>
          <Label>Fator:</Label>
          <Value>{factor}</Value>
        </div>

        <div>
          <Label>Fabricante:</Label>
          <Value noWrap>{manufacturer}</Value>
        </div>

        <div>
          <Label>Quantidade:</Label>
          <Value>{quantity}</Value>

          <Label>Validade:</Label>
          <Value>{validity}</Value>

          <Label>Lote:</Label>
          <Value noWrap>{lot}</Value>
        </div>

        <div>
          <Label>Data:</Label>
          <Value>{dateParsed}</Value>

          <Label>Horário:</Label>
          <Value>{hourParsed}</Value>
        </div>

        <div>
          <Label>Dispensado por:</Label>
          <Value noWrap>{dispensed_by}</Value>
        </div>

        <div>
          <Label>Recebido por:</Label>
          <Value noWrap>{received_by} </Value>
        </div>
      </Content>
    </Container>
  );
};

Ticket.propTypes = {
  data: PropTypes.func.isRequired,
  dispensed_by: PropTypes.string.isRequired,
};

export default Ticket;
